import { render, staticRenderFns } from "./water-consent-condition-type-volume.vue?vue&type=template&id=a35a2eac&"
import script from "./water-consent-condition-type-volume.vue?vue&type=script&lang=ts&"
export * from "./water-consent-condition-type-volume.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports